import { render, staticRenderFns } from "./SidebarDefaultNavigationMain.vue?vue&type=template&id=ee0a71ce&scoped=true&"
import script from "./SidebarDefaultNavigationMain.vue?vue&type=script&lang=js&"
export * from "./SidebarDefaultNavigationMain.vue?vue&type=script&lang=js&"
import style0 from "./SidebarDefaultNavigationMain.vue?vue&type=style&index=0&id=ee0a71ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0a71ce",
  null
  
)

export default component.exports